import { useFuriPairs, Wrapper, Pair, Text, Furi } from 'react-furi';

function Navbar() {
    // Detectar la página actual
    const currentPath = window.location.pathname;
    const isOnCuentos = currentPath === '/cuentosDashboard';
    
    // Memoized generation of text and accompanying furigana pairs
    const pairs = useFuriPairs("読んで", "よんで");

    return (
        <nav className="bg-primary-800 py-4 px-6 shadow-lg fixed top-0 w-full flex justify-between items-end z-40 border-b-2 border-primary-600">
            <a 
                href="/" 
                className="no-underline font-bold font-japanese flex items-end group" 
                draggable="false"
            >
            <div className="flex items-end space-x-2 transition-colors duration-200">

                <div className=''>
                    <Wrapper>
                        {pairs.map(([furiText, text], index) => (
                            <Pair key={text + index}>
                                <Furi className="text-pearl-50 group-hover:text-japanese-cherry transition-colors duration-200">{furiText}</Furi>
                                <Text className="text-pearl-50 text-[35px] group-hover:text-japanese-cherry transition-colors duration-200">{text}</Text>
                            </Pair>
                        ))}
                    </Wrapper>

                </div>
                <div>
                    <span className="text-pearl-200 text-[17px] mb-0 pb-0 group-hover:text-japanese-cherry transition-colors duration-200">Yonde</span>
                </div>
            </div>
            </a>
            
            <div className="flex items-end space-x-6">
                <a 
                    href="/cuentosDashboard" 
                    className={`text-xl no-underline transition-all duration-200 px-4 py-2 rounded-lg transform ${
                        isOnCuentos 
                            ? 'text-sage-300 scale-110 drop-shadow-lg' 
                            : 'text-pearl-100 hover:text-sage-300 hover:scale-110 hover:drop-shadow-lg'
                    }`}
                    draggable="false"
                >
                    📚 Cuentos
                </a>
            </div>
        </nav>
    );
}

export default Navbar;